import { makePrioStyles } from '../../../theme/utils';

export const useChartStyles = makePrioStyles((theme) => ({
  chartCard: {
    height: '320px',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.regular,
    backgroundColor: theme.colors.application.background.default,
    borderRadius: theme.borderRadius.regular,
    border: `1px solid ${theme.colors.application.border}`,
  },
  scrollableChartCard: {
    height: '400px',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.regular,
    backgroundColor: theme.colors.application.background.default,
    borderRadius: theme.borderRadius.regular,
    border: `1px solid ${theme.colors.application.border}`,
  },
  scrollableContainer: {
    flex: 1,
    overflowY: 'auto',
    paddingRight: theme.spacing.small,
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.colors.application.background.light,
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.colors.application.border,
      borderRadius: '3px',
      '&:hover': {
        background: theme.colors.application.typography.muted,
      },
    },
  },
  chartItem: {
    marginBottom: theme.spacing.small,
    cursor: 'pointer',
    padding: theme.spacing.small,
    borderRadius: theme.borderRadius.small,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.colors.application.background.hover,
      transform: 'translateY(-1px)',
      boxShadow: `0 2px 4px ${theme.colors.application.overlay.default}`,
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    '& .prio-bar-chart-container-outer': {
      height: 'auto !important',
      minHeight: '46px !important',
      marginBottom: '0 !important',
    },
    '& .prio-bar-chart-container': {
      height: 'auto !important',
      minHeight: '24px !important',
    },
    '& .prio-bar-chart-bar': {
      minHeight: '20px !important',
    },
  },
  chartLabel: {
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: theme.spacing.small,
    color: theme.colors.application.typography.default,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:hover': {
      color: theme.colors.base.primary.default,
    },
  },
  chartContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.regular,
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: 600,
    paddingBottom: theme.spacing.small,
    borderBottom: `1px solid ${theme.colors.application.border}`,
    marginBottom: theme.spacing.regular,
  },
  pieChartContainer: {
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  barChartContainer: {
    cursor: 'pointer',
    borderRadius: theme.borderRadius.small,
    overflow: 'hidden',
    marginTop: theme.spacing.small,
    '&:hover': {
      opacity: 0.9,
    },
    '& .prio-bar-chart-container-outer': {
      height: 'auto !important',
      minHeight: '20px !important',
    },
    '& .prio-bar-chart-container': {
      height: 'auto !important',
      minHeight: '20px !important',
    },
  },
  taskCount: {
    fontSize: '12px',
    color: theme.colors.application.typography.muted,
    fontWeight: 400,
  },
  emptyBarPlaceholder: {
    height: '24px',
    backgroundColor: theme.colors.application.background.light,
    borderRadius: theme.borderRadius.small,
    border: `1px dashed ${theme.colors.application.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    color: theme.colors.application.typography.muted,
    marginTop: theme.spacing.small,
  },
}));
